// extracted by mini-css-extract-plugin
export var Radio = "styles-module--Radio--3PuOD";
export var Choices = "styles-module--Choices--_h-BW";
export var Choice = "styles-module--Choice--9biRG";
export var Choice_Checked = "styles-module--Choice_Checked--JBIW_";